import { render } from "./MediaFileBlock.vue?vue&type=template&id=11c10576"
import script from "./MediaFileBlock.vue?vue&type=script&lang=js"
export * from "./MediaFileBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__